import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import NoData from './no-data';
import SubHeader from '../header/subheader';
// import { topics  } from '../../utils/dummy-datas';
import TableBodyRow from '../topics/table-body-row';
import Conversations from '../pages/conversations';
import useThemeQuery from '../../graphql/queries/toggle-theme';
// import useTopicQuery from '../../graphql/queries/topic';
import Loading from './loading';
import { conversationsData, topicsData } from '../../utils/dummyDatas';

const Topic = ({ params, router }) => {
    const { data: theme } = useThemeQuery();
    const { formatMessage } = useIntl();

    const [data, setData] = useState(null);

    useEffect(() => {
        setData({
            topic: topicsData.topics.find((topic) => topic.topicId === params.topicId),
            conversations: conversationsData.conversations[0],
        })
    }, [params.topicId])
    // const { loading, data } = useTopicQuery({
    //     topicId: params.topicId,
    //     start:  "2016-05-01",
    //     dateCompareType:  'LAST_7_DAYS',
    //     timezone:  "Europe/Paris",
    //     page:  1,
    //     size:  10,
    //     way:  "DESC",
    // });

    // useEffect(() => {
    //     const topic = topics.find(t => t.name === params.name);
    //     setDemo(topic);
    // }, [ params.name ])

    // if (!data) return 'No data';
    // data && console.log('topic: ', data.topic);

    if (!data) return <Loading />;

    return (
        data
            ? <>
                <SubHeader title={params.name} theme={theme && theme.theme}/>
                <TableBodyRow data={data.topic} router={router} theme={theme && theme.theme}/>
                <Conversations topic dataTopic={data.conversations}/>
            </>
            :   <NoData
                    message={formatMessage({id:"app.no.topic.found", defaultMessage:"No Topic found"})}
                    theme={theme}
                />
    )
}

export default Topic;
